import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-salary-wage-master',
  templateUrl: './view-salary-wage-master.component.html',
  styleUrls: ['./view-salary-wage-master.component.css']
})
export class ViewSalaryWageMasterComponent implements OnInit {
  @Input() selectedData: any;
  constructor(public activeModal: NgbActiveModal) { }

  minWageData: any[] = [];

  ngOnInit() {
    console.log('Selected Data:', this.selectedData);

    const groupedByGroupKey = new Map();
    this.selectedData.forEach(item => {
      const groupKey = `${item.ContractorVendor_Code}-${item.State_Code}-${item.Plant_Code}-${item.MinWageMasterID}`;
      if (!groupedByGroupKey.has(groupKey)) {
        groupedByGroupKey.set(groupKey, {
          groupKey,
          Contractor: item.Contractor,
          State: item.State,
          Plant: item.Plant,
          Date: this.formatDateRange(item.ApplicableDate, item.ValiduptoDate),
          wageMasterID: item.MinWageMasterID,
          components: new Map()
        });
      }

      const group = groupedByGroupKey.get(groupKey);
      const compKey = item.Component_Code;

      if (!group.components.has(compKey)) {
        group.components.set(compKey, {
          Component_Code: compKey,
          ShortName: item.ShortName,
          rawData: []
        });
      }

      group.components.get(compKey).rawData.push(item);
    });

    const excludedFields = new Set([
      "ContractorVendor_Code", "Contractor", "SubContractorVendor_Code", "Sub-Contractor",
      "CategoryMIL_Code", "AreaMIL_Code", "State_Code", "State", "Plant_Code", "Plant",
      "MinWageMasterID", "Component_Code", "ShortName", "ProcessOrderNo",
      "IsMinWageConfigValue", "ApplicableDate", "ValiduptoDate"
    ]);

    this.minWageData = Array.from(groupedByGroupKey.values()).map(group => ({
      ...group,
      components: Array.from(group.components.values())
      .map((comp: any) => {
        const mergedSkills = {};
        const IsMinWageConfigValue = comp.rawData[0].IsMinWageConfigValue || 0;
    
        comp.rawData.forEach(entry => {
          Object.keys(entry).forEach(key => {
            if (!excludedFields.has(key) && entry[key] != null) {
              mergedSkills[key] = entry[key];
            }
          });
        });
    
        return {
          IsMinWage: IsMinWageConfigValue,
          Component: comp.ShortName,
          ...mergedSkills
        };
      })
      .sort((a, b) => b.IsMinWage - a.IsMinWage)
      .reduce((acc: any[], comp: any, index: number, comps: any[]) => {
        acc.push(comp);
    
        const isLastMinWage = comp.IsMinWage === 1 &&
          (index === comps.length - 1 || comps[index + 1].IsMinWage !== 1);
    
        if (isLastMinWage) {
          const minWageComponents = acc.filter(c => c.IsMinWage === 1);
    
          const totalSkills = minWageComponents.reduce((total: any, c: any) => {
            Object.keys(c).forEach(key => {
              if (key !== "IsMinWage" && key !== "Component" && typeof c[key] === "number") {
                total[key] = (total[key] || 0) + c[key];
              }
            });
            return total;
          }, {});
    
          const totalRow = {
            IsMinWage: 1,
            bgColor: "900", // ← ✅ remove semicolon
            Component: "Total Min Wage Amount",
            ...totalSkills
          };
          
          const divisionRow = {
            IsMinWage: 1,
            bgColor: "900", // ← ✅ another color for this row (or same if preferred)
            Component: "Overtime per Hour",
            ...Object.entries(totalSkills).reduce((acc, [key, value]) => {
              acc[key] = typeof value === "number" ? (value / 8) * 3 : value;
              return acc;
            }, {})
          };
          
          acc.push(totalRow, divisionRow);
        }
    
        return acc;
      }, [])
        .reduce((acc: any[], val: any) => acc.concat(val), []) // Flatten the array manually
    }));

    console.log("Grouped by GroupKey with Components and Total Min Wage Amount:", this.minWageData);

    this.minWageData.forEach(group => {
      const headersSet = new Set<string>();
    
      const excludedHeaders = new Set(["IsMinWage","bgColor"]);
      group.components.forEach(component => {
        Object.keys(component).forEach(key => {
          if (!excludedHeaders.has(key) && key !== "Component") {
            headersSet.add(key);
          }
        });
      });
    
      group.tableHeaders = ["Component"].concat(Array.from(headersSet).sort());
    });
  }


  formatDateRange(applicableDate: string, validUptoDate: string): string {
    if (!applicableDate || !validUptoDate) return '';

    let startDate = new Date(applicableDate);
    let endDate = new Date(validUptoDate);

    let formattedStart = startDate.toLocaleDateString('en-GB');
    let formattedEnd = endDate.toLocaleDateString('en-GB');

    return `${formattedStart} to ${formattedEnd}`;
  }

  isZeroRow(item: any, headers: string[]): boolean {
    return headers.every(header => Number(item[header]) === 0);
  }
}